import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {UserProvider } from './context/UserProvider'
import { SocketProvider } from './context/SocketProvider';
import { BASE_URL } from './appsetting/appsetting';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <SocketProvider serverUrl={BASE_URL}>
    <UserProvider>
      <App />
    </UserProvider>
  </SocketProvider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
